import { useState } from "react";
import { toast } from "sonner";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "./ui/dialog";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Button } from "./ui/button";
import { api, formatError } from "../lib/api";

export default function EditTripDialog({ trip, onClose, onSaved }) {
  const isoDate = (trip.date || "").slice(0, 10);
  const isoTime = (trip.date || "").slice(11, 16) || "07:00";
  const [date, setDate] = useState(isoDate);
  const [time, setTime] = useState(isoTime);
  const [spotsTotal, setSpotsTotal] = useState(trip.spots_total || 1);
  const [price, setPrice] = useState(trip.price_per_person || 0);
  const [description, setDescription] = useState(trip.description || "");
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    try {
      const payload = {
        date: new Date(`${date}T${time}:00`).toISOString(),
        spots_total: Number(spotsTotal),
        price_per_person: Number(price),
        description,
      };
      await api.patch(`/trips/${trip.trip_id}`, payload);
      toast.success("Annonce mise à jour");
      onSaved?.();
    } catch (e) {
      toast.error(formatError(e.response?.data?.detail) || e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose?.()}>
      <DialogContent className="bg-blanc max-w-md" data-testid="edit-trip-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl text-ocean">Modifier l'annonce</DialogTitle>
          <DialogDescription className="sr-only">
            Mettez à jour la date, l'heure, le nombre de places, la participation aux frais ou la description de votre annonce.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 mt-2">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-[11px] uppercase tracking-widest text-bretagne font-bold">Date</label>
              <Input data-testid="edit-date" type="date" value={date} onChange={(e) => setDate(e.target.value)}
                className="mt-1.5 bg-brume/30 border-brume rounded-xl" />
            </div>
            <div>
              <label className="text-[11px] uppercase tracking-widest text-bretagne font-bold">Heure</label>
              <Input data-testid="edit-time" type="time" value={time} onChange={(e) => setTime(e.target.value)}
                className="mt-1.5 bg-brume/30 border-brume rounded-xl" />
            </div>
            <div>
              <label className="text-[11px] uppercase tracking-widest text-bretagne font-bold">Places (total)</label>
              <Input data-testid="edit-spots" type="number" min={1} max={20} value={spotsTotal}
                onChange={(e) => setSpotsTotal(e.target.value)}
                className="mt-1.5 bg-brume/30 border-brume rounded-xl" />
            </div>
            <div>
              <label className="text-[11px] uppercase tracking-widest text-bretagne font-bold">Participation (€)</label>
              <Input data-testid="edit-price" type="number" min={0} value={price}
                onChange={(e) => setPrice(e.target.value)}
                className="mt-1.5 bg-brume/30 border-brume rounded-xl" />
            </div>
          </div>
          <div>
            <label className="text-[11px] uppercase tracking-widest text-bretagne font-bold">Description</label>
            <Textarea data-testid="edit-description" rows={4} value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="mt-1.5 bg-brume/30 border-brume rounded-xl" />
          </div>
        </div>

        <DialogFooter className="mt-4 gap-2">
          <Button variant="ghost" onClick={onClose} className="text-bretagne">Annuler</Button>
          <Button
            data-testid="edit-save"
            onClick={save} disabled={busy}
            className="bg-ocean hover:bg-ocean/90 text-blanc font-bold rounded-full px-5"
          >
            {busy ? "Enregistrement…" : "Enregistrer"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
